


// Signup overlay

let signupButtons = document.querySelectorAll('.open-signup-overlay')
let signupOverlay = document.querySelector('#signup-overlay')
let closeSignupOverlay = document.querySelectorAll('.close-signup-overlay')
signupButtons.forEach(function(element){
	element.addEventListener('click', (e) => {
		e.preventDefault()
		gsap.to(signupOverlay, {autoAlpha: 1})
	})
})
closeSignupOverlay.forEach(function(element){
	element.addEventListener('click', () => {
		gsap.to(signupOverlay, {autoAlpha: 0})
	})
})

//Stylists modal

$('.stylist a').on('click', function(e){
	
	if (!$(this).is('#paul-percival')) {

		e.preventDefault();
		var url = $(this).attr('href');
		$('.stylist-modal-content').load(url + ' #MainContent', () => {
			gsap.timeline(
				{
				defaults: {
					duration: .3
				}
			}
		).to('.stylist-modal, .stylist-modal-inner', {autoAlpha: 1}).to('.stylist-modal .fiu', {autoAlpha: 1})
		});
		
	}
		
})


// let stylists = document.querySelectorAll('.stylist button')
let stylistOverlay = document.querySelector('.stylist-modal')
let closeStylistOverlay = document.querySelectorAll('.close-stylist-modal')

// stylists.forEach(function(element){
// 	element.addEventListener('click', (e) => {
// 		console.log(element.dataset.stylist);
// 		gsap.to(stylistOverlay, {autoAlpha: 1})
// 		gsap.to('[data-stylist-table="'+element.dataset.stylist+'"]', {autoAlpha: 1})
// 	})
// })
closeStylistOverlay.forEach(function(element){
	element.addEventListener('click', () => {
		gsap.to(stylistOverlay, {autoAlpha: 0})
		gsap.to('.price-list', {autoAlpha: 0})
	})
})
if (document.querySelector('#stylist-overlay')) {
document.querySelector('#stylist-overlay').addEventListener('click', (e) => {
	gsap.to(stylistOverlay, {autoAlpha: 0})
    gsap.to('.price-list', {autoAlpha: 0})
})
}


$('.cta-card').each(function(){
	let card = $(this);

	let parallax = gsap.timeline({paused: true}).fromTo(card.find('.media'), {yPercent: 10}, { yPercent: -10})

	ScrollTrigger.create({
		animation: parallax,
		trigger: card,
		start: 'top bottom',
		end: 'bottom top',
		// markers: true,
		scrub: true,
		ease: 'linear'
	})
  })



$(document).on('click', '.mega-menu:not(.open)', function(){

// close others
	let others = $(document).find('.mega-menu.open')
	gsap.to(others.find('.mega-menu__content'), {autoAlpha: 0})
	others.removeClass('open')

	gsap.set('.xproduct-template .header-wrapper', { backgroundColor: '#fff' })

	$(this).addClass('open')
	let dropdown = $(this).find('.mega-menu__content')
	
	gsap.timeline()
	.set(dropdown, {y: 0, autoAlpha: 1})
	.from(dropdown, {
		height: 0,
		padding: 0
	})
	.fromTo(dropdown.find('.mega-menu__list > li'), {
		autoAlpha: 0,
	}, {
		autoAlpha: 1,
		stagger: .1
	}).to('.menu-opacity', {autoAlpha: 1}, 0)
})

$(document).on('click', '.mega-menu.open', function(){


	$(this).removeClass('open')

	let dropdown = $(this).find('.mega-menu__content')
	
	let closeMenu = gsap.timeline({
		defaults: {
			duration: .3
		},
		onComplete: () => {
			gsap.set(closeMenu, {clearProps: true})
		}
	})
	.to(dropdown, {
		autoAlpha: 0
	})
	.to('.xproduct-template .header-wrapper', { backgroundColor: 'transparent' }, '-=.15')
	.to('.menu-opacity', {autoAlpha: 0}, 0)

})

$(document).on('click', '.menu-opacity', function(){

	$('.mega-menu').removeClass('open')

	let dropdown = $(document).find('.mega-menu__content')
	
	let closeMenu = gsap.timeline({
		defaults: {
			duration: .3
		},
		onComplete: () => {
			gsap.set(closeMenu, {clearProps: true})
		}
	})
	.to(dropdown, {
		autoAlpha: 0
	})
	.to('.xproduct-template .header-wrapper', { backgroundColor: 'transparent' }, '-=.15')
	.to('.menu-opacity', {autoAlpha: 0}, 0)

})

// Mega menu opacity

// let megaMenus = document.querySelectorAll('.mega-menu');
// megaMenus.forEach(function(element){
// 	element.addEventListener('click', (e) => {
// 		if (element.hasAttribute('open')) {
// 			gsap.set('.menu-opacity', {autoAlpha: 0})
// 		} else {
// 			gsap.set('.menu-opacity', {autoAlpha: 1})
// 		}
// 	})
// })

let mobileMenu = document.querySelectorAll('#Details-menu-drawer-container');
mobileMenu.forEach(function(element){
	element.addEventListener('click', (e) => {
		// if (element.hasAttribute('open')) {
		// 	console.log(2);
		// 	gsap.set('#menu-opacity', {autoAlpha: 0})
		// } else {
		// }
		gsap.set('#menu-opacity', {autoAlpha: 1})
	})
})

// if (document.getElementById('#menu-opacity')) {

// 	document.getElementById('#menu-opacity').addEventListener('click', (e) => {
// 		gsap.set('#menu-opacity', {autoAlpha: 0})
// 		if (mobileMenu[0].hasAttribute('open')) {
// 			mobileMenu[0].querySelector('summary').click()
// 		}
// 	})
// }
	
// document.querySelector('.menu-opacity').addEventListener('click', (e) => {
// 	console.log('test');
// 	gsap.set('.menu-opacity', {autoAlpha: 0})
// 	if (mobileMenu[0].hasAttribute('open')) {
// 		mobileMenu[0].querySelector('summary').click()
// 	}
// })
// document.querySelector('#Details-menu-drawer-container:not(.menu-opening)').addEventListener('click', (e) => {
// 	gsap.set('#menu-opacity', {autoAlpha: 1})
// })
// document.querySelector('#Details-menu-drawer-container.menu-opening').addEventListener('click', (e) => {
// 	gsap.set('#menu-opacity', {autoAlpha: 0})
// })

document.querySelector('#fake-close-button').addEventListener('click', (e) => {
	mobileMenu[0].querySelector('summary').click()
})



// Quiz


function emailIsValid(email) {
	return /\S+@\S+\.\S+/.test(email);
}
function startQuiz() {
	$(".loading-gif").hide();
	let products = [];
	new TimelineMax()
		.set($(".question0").find(".qi-wrap"), { className: "+=show-img" })
		.set($(".question0").find(".qi-wrap img"), { autoAlpha: 1 }, "+=.25")
		.to($(".question0 .question__titles"), 0.3, { autoAlpha: 1 })
		.staggerTo($(".question0 .quiz__field"), 0.3, { autoAlpha: 1 }, 0.1);
	// collect user info
	$(".quiz__field")
		.find("input, select")
		.on("change keyup", function () {
			// toggle button depending if input has value or not

			if (
				$(".quiz__name input").val() &&
				$(".quiz__gender select").val() &&
				$(".quiz__age select").val()
			) {
				if ($(".quiz__email input").val()) {
					$(".quiz__confirm").css("display", "flex");
					$(".question__start").attr("disabled", true);
				} else {
					$(".quiz__confirm").css("display", "none");
					// $('.question__start').attr('disabled', false)
					start();
				}
			} else {
				$(".question__start").attr("disabled", true);
			}
		});
	function start() {
		$(".question__start").attr("disabled", false);
		$(".question__start")
			.off()
			.on("click", function () {
				// move to next q
				$(this)
					.closest(".question")
					.addClass("question--hide")
					.next()
					.removeClass("question--hide");
				// animate content
				new TimelineMax()
					.set(".question:not(.question--hide) .qi-wrap", {
						className: "+=show-img",
					})
					.set(
						".question:not(.question--hide) .qi-wrap img",
						{ autoAlpha: 1 },
						"+=.25"
					)
					.to(
						".question:not(.question--hide) .question__titles",
						0.3,
						{ autoAlpha: 1 }
					)
					.staggerTo(
						".question:not(.question--hide) .answer",
						0.3,
						{ autoAlpha: 1 },
						0.1
					);
				//update dots
				$(".dot.on").removeClass("on").next().addClass("on");
				// submit data to form
				$(".mce-FNAME").val($(".quiz__name input").val());
				$(".mce-QUIZ2").val($(".quiz__gender select").val());
				$(".mce-QUIZ1").val($(".quiz__age select").val());

				if ($(document).find(".quiz__confirm input").hasClass("checked")) {
					$(".mce-EMAIL").val($(document).find(".quiz__email input").val());
					$(".mce-QUIZ8").val("");
				} else {
					$(".mce-EMAIL").val(
						"noemail" +
							Math.floor(Math.random() * 1111111111) +
							"@prwebsitequiz.com"
					);
					$(".mce-QUIZ8").val("True");
				}
			});
	}
	$(".quiz__confirm")
		.find("input")
		.on("change", function () {
			if (this.checked) {
				$(".question__start").attr("disabled", false);
				$(this).addClass("checked");
				if (emailIsValid($(document).find(".quiz__email input").val())) {
					start();
				} else {
					alert("Please enter a valid email address");
				}
			} else {
				$(".question__start").attr("disabled", true);
				$(this).removeClass("checked");
			}
		});

	$(".answer")
		.off()
		.on("click", function () {
			// remove all selections before selecting new option
			$(this)
				.addClass("active")
				.removeClass("inactive")
				.siblings()
				.removeClass("active")
				.addClass("inactive");
			$(this)
				.closest(".question")
				.find(".question__next")
				.attr("disabled", false);
		});
	// navigation
	$(".question__prev")
		.off()
		.on("click", function () {
			// animate content
			// TweenMax.to('.question:not(.question--hide) .question__content', 1, { autoAlpha: 0 })
			// Move to previous q
			$(this)
				.closest(".question")
				.addClass("question--hide")
				.prev()
				.removeClass("question--hide");
			// remove last item added to array
			products.pop();
			// update dots
			$(".dot.on").removeClass("on").prev().addClass("on");
		});
	$(".question__next:not(.question__submit)")
		.off()
		.on("click", function () {
			// move to next q
			$(this)
				.closest(".question")
				.addClass("question--hide")
				.next()
				.removeClass("question--hide");
			// add answer to array
			products.push(
				$(this)
					.closest(".question")
					.find(".active button")
					.attr("data-products")
			);
			// TweenMax.to('.question:not(.question--hide) .question__content', 1, { autoAlpha: 1 })
			// update dots
			$(".dot.on").removeClass("on").next().addClass("on");

			// animate content
			new TimelineMax()
				.set($(document).find(".question:not(.question--hide) .qi-wrap"), {
					className: "+=show-img",
				})
				.set(
					".question:not(.question--hide) .qi-wrap img",
					{ autoAlpha: 1 },
					"+=.25"
				)
				.to(".question:not(.question--hide) .question__titles", 0.3, {
					autoAlpha: 1,
				})
				.staggerTo(
					".question:not(.question--hide) .answer",
					0.3,
					{ autoAlpha: 1 },
					0.1
				);
			// submit data to form
			let form_field = $(this)
				.closest(".question")
				.attr("data-formfield");
			let ff = $(this)
				.closest(".question")
				.find(".answer.active button")
				.html();
			$(".mce-" + form_field).val(ff);
		});
	// Submit
	$(".question__submit")
		.off()
		.on("click", function () {
			// Hide dots
			$(".dots-wrapper").hide();
			// add final answer to array
			products.push(
				$(this)
					.closest(".question")
					.find(".active button")
					.attr("data-products")
			);

			// Save results to local
			localStorage.setItem("quiz", JSON.stringify(products));
			// submit data to form and submit
			let form_field = $(this)
				.closest(".question")
				.attr("data-formfield");
			let ff = $(this)
				.closest(".question")
				.find(".answer.active button")
				.html();
			$(".mce-" + form_field).val(ff);
			$('.mailchimp-form .subscribe-contact input[type="submit"]')
				.trigger("click")
				.css("background", "red");
			// $('.mailchimp-form .update-contact input[type="submit"]').trigger('click').css('background', 'red')
			// show results
			$(".quiz").hide();
			$(".results").show();
			load_products();
			// Add personal info to message
			let quiz_name = $(".quiz__name input").val();
			localStorage.setItem("quiz_name", JSON.stringify(quiz_name));
			$(".results__name").html(quiz_name);
			let quiz_hairtype = $(".question1 .active button").html();
			localStorage.setItem(
				"quiz_hairtype",
				JSON.stringify(quiz_hairtype)
			);
			$(".results__hairtype").html(quiz_hairtype);
			let quiz_washfrequency = $(".question2 .active button").html();
			localStorage.setItem(
				"quiz_washfrequency",
				JSON.stringify(quiz_washfrequency)
			);
			let quiz_washtime = $(".question3 .active button").html();
			localStorage.setItem(
				"quiz_washtime",
				JSON.stringify(quiz_washtime)
			);
			let quiz_haircrazy = $(".question4 .active button").html();
			localStorage.setItem(
				"quiz_haircrazy",
				JSON.stringify(quiz_haircrazy)
			);
			let quiz_hairgoals = $(".question5 .active button").html();
			localStorage.setItem(
				"quiz_hairgoals",
				JSON.stringify(quiz_hairgoals)
			);
			// postToGoogle()
		});
	// Overrides
	$(".question1 .question__next").on("click", function () {
		// Show correct future option depending on answer to q1
		if ($(".question1 .answer1").hasClass("active")) {
			$(".question5 .answer1a").show();
			$(".question5 .answer1b").hide();
		} else {
			$(".question5 .answer1a").hide();
			$(".question5 .answer1b").show();
		}
	});
	$(".question4 .question__next").on("click", function () {
		// replace selected product in array with alternates or reset to selection
		if ($(".question4 .answer4").hasClass("active")) {
			products[2] = $(".question3 .active button").attr("data-products");
			products[1] = "percy-and-reed-oh-so-smooth-frizz-fixer";
		} else if ($(".question4 .answer5").hasClass("active")) {
			products[1] = $(".question2 .active button").attr("data-products");
			products[2] = "percy-reed-bye-bye-dry-hydrating-tlc-mask";
		} else {
			products[1] = $(".question2 .active button").attr("data-products");
			products[2] = $(".question3 .active button").attr("data-products");
		}
	});
}
if (localStorage.getItem("quiz") === null) {
	$(".loading-gif").show();
	$(window).on("load", function () {
		$(".loading-gif").hide();
		$(".quiz").show();
		$(".dots-wrapper").show();
		startQuiz();
	});
} else {
	// show results
	$(".quiz").hide();

	$(".dots-wrapper").hide();
	load_products();
	// Add personal info to message
	var quiz_name = JSON.parse(localStorage.getItem("quiz_name"));
	$(".results__name").html(quiz_name);
	var quiz_hairtype = JSON.parse(localStorage.getItem("quiz_hairtype"));
	$(".results__hairtype").html(quiz_hairtype);
}
function load_products() {
	$(".loading-gif").show();
	// Get quiz data
	var saved_products = JSON.parse(localStorage.getItem("quiz"));
	let counter1 = 0;
	let product_handles;

	saved_products.forEach((element, index) => {
		// split array into each product url
		product_handles = saved_products[index].split(", ");
		product_handles.forEach((element, index) => {
			// count individual urls
			counter1++;
		});
	});
	// console.table(saved_products)

	let counter2 = 0;
	$(".result").each(function (i) {
		product_handles = saved_products[i].split(", ");
		// Load product from each url
		product_handles.forEach((element, index) => {
			console.log(element);
			$(this)
				.find(".result__result .row")
				.append('<div class="result' + index + ' mb-3"></div>');
			$(this)
				.find(".result__result .result" + index)
				.load("/products/" + element + " .quiz__product", function () {
					// if last
					counter2++;
					if (counter1 === counter2) {
						$(".results").show();
						$(".results-wrapper").show();
						$(".loading-gif").hide();
						add_all();
					}

					// console.table(element);
				});
		});
	});
	// add_all()

	function add_all() {
		let product_ids = [];
		$(".quiz__product").each(function () {
			product_ids.push($(this).find("button").attr("data-varid"));
		});
		$(".results-wrapper").before(
			'<button class="addcart-all btn btn-black no-hover">Add all to basket</button><div class="addcart-all-message xtext-center"></div>'
		);
		$(".results__buttons .col-12").prepend(
			'<button class="addcart-all xtext-center btn btn-black no-hover">Add all to basket</button><div class="addcart-all-message"></div>'
		);

		$(document).on("click", ".addcart-all", function () {
			const cart_message = $(document).find(".addcart-all-message");
			cart_message
				.removeClass("message-success")
				.addClass("loading")
				.html(
					'<div class="loading-gif xflex xjustify-center xw-full xh-10"><svg class="xanimate-spin xh-10 xw-10 xtext-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="xopacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="xopacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg></div>'
				);
			let count = 0;

			product_ids.forEach((element, index) => {
				count++;
				if (count != product_ids.length) {
					CartJS.addItem(element, 1);
				} else {
					// last one
					CartJS.addItem(
						element,
						1,
						{},
						{
							// Define a success callback to display a success message.
							success(data, textStatus, jqXHR) {
								cart_message
									.removeClass("loading")
									.addClass("message-success")
									.html("Successfully added all to basket.");
								// setTimeout(() => {
								//     cart_message.html('').removeClass('message-success');
								// }, 10000);
								// jQuery(".mini-cart").load(
								// 	"/cart #MainContent #main-cart"
								// );

								$(document).on('cart.requestComplete', function(event, cart) {
									$('.cart-count-bubble span').html(cart.item_count);
								});

								product_ids = [];
								$(".addcart-all").remove();
							},
						}
					);
				}
			});
		});
	}
}
$(".quiz__reset")
	.off()
	.on("click", function () {
		$(".results").hide();
		$(".quiz").hide();
		$(".dots-wrapper").hide();
		$(".loading-gif").show();
		setTimeout(() => {
			$(".answer").removeClass("active inactive");
			$(".quiz").show();
			$(".dot.on").removeClass("on");
			$(".dots-wrapper").show().find(".dot:first-child").addClass("on");
			$(".result__result .row").html("");
			$(".question__next").attr("disabled", true);
			$(".question").addClass("question--hide");
			$(".question0").removeClass("question--hide");
			$(".quiz__name input").val("");
			$(".quiz__email input").val("");
			$(".quiz__gender select").val("Choose");
			$(".quiz__age select").val("Choose");
			$(".question__start").attr("disabled", true);
			$(".addcart-all").remove();
			$(".addcart-all-message").remove();
			$(".results-wrapper").hide();
			$(
				'.mailchimp-form input[type="text"], .mailchimp-form input[type="email"]'
			).val("");

			new TimelineMax()
				.set(".question .qi-wrap", { className: "-=show-img" })
				.set(".question .qi-wrap img", { autoAlpha: 0 })
				.set(".question .question__titles", { autoAlpha: 0 })
				.set(".question .answer", { autoAlpha: 0 });

			localStorage.removeItem("quiz");
			localStorage.removeItem("quiz_name");
			localStorage.removeItem("quiz_hairtype");
			localStorage.removeItem("quiz_washfrequency");
			localStorage.removeItem("quiz_washtime");
			localStorage.removeItem("quiz_haircrazy");
			localStorage.removeItem("quiz_hairgoals");

			startQuiz();
		}, 1000);
	});

	$(document).on("click", ".addcart", function () {
		const cart_message = $(this).siblings(".cart-message");
		const var_id = $(this).attr("data-varid");
		CartJS.addItem(
			var_id,
			1,
			{},
			{
				// Define a success callback to display a success message.
				success(data, textStatus, jqXHR) {
					cart_message
						.addClass("message-success")
						.html("Successfully added to basket.");
					// setTimeout(() => {
					//     cart_message.html('').removeClass('message-success');
					// }, 10000);
					// jQuery(".mini-cart").load("/cart #MainContent #main-cart");

					$(document).on('cart.requestComplete', function(event, cart) {
						$('.cart-count-bubble span').html(cart.item_count);
					});

				},
				// Define an error callback to display an error message.
				error(jqXHR, textStatus, errorThrown) {
					cart_message
						.addClass("message-error")
						.html("There was a problem adding to the basket!");
					setTimeout(() => {
						cart_message.html("").removeClass("message-error");
					}, 10000);
				},
			}
		);
	});
	$(document).on("mouseover", ".question__tooltip", function () {
		$(".question__tooltipAnswer").show();
	});
	$(document).on("mouseleave", ".question__tooltip", function () {
		$(".question__tooltipAnswer").hide();
	});





	// Normal bundle code

if ($(".bundle-page").length) {
	let bbCount = 0;

	$(document).on("click", ".bb-add-product", function () {
		if (bbCount < 1) {
			$(".bundle-builder__bundle .h2").hide();
		}

		bbCount++;

		if (bbCount < 5) {
			let bbProdID = $(this).attr("data-prodid");
			let bbProdImg = $(this)
				.closest(".col-sm-6")
				.find(".featured-collection__image img")
				.attr("src");
			let bbProdName = $(this).siblings("h3").html();
			let bbProdVolume = $(this).siblings("h4").html();

			if (!bbProdVolume) {
				bbProdVolume = " ";
			}

			$("#my-bundle").append(
				'<li class="col-sm-6 col-md-3 xflex xflex-col xcol-span-1 xtext-xs lg:xtext-base xleading-tight" data-id="' +
					bbProdID +
					'"><img src="' +
					bbProdImg +
					'"><span class="xblock">' +
					bbProdName +
					'<span style="margin-left: 10px; color: gray;">' +
					bbProdVolume +
					'</span></span><button style="margin-top: 10px;" class="button-alt bb-remove-product">Remove</button></li>'
			);

			$(this).siblings(".tick").addClass("showtick");

			if (bbCount == 4) {
				$(".bb-add-product").each(function () {
					$(this).prop("disabled", true);
					$(this).html("Bundle complete");
				});

				$("#bb-add-to-cart")
					.addClass("xinline-block")
					.removeClass("xhidden");
			}
		}
	});

	$(document).on("click", ".bb-remove-product", function () {
		$(".bb-add-product").each(function () {
			$(this).prop("disabled", false);
			$(this).html("Add to bundle");
		});

		let thisid = $(this).closest("li").attr("data-id");

		$(this).closest("li").remove();

		if (!$('#my-bundle li[data-id="' + thisid + '"]').length) {
			$(".bundle-builder__options")
				.find('button[data-prodid="' + thisid + '"]')
				.siblings(".tick")
				.removeClass("showtick");
		}

		bbCount--;

		if (bbCount < 1) {
			$(".bundle-builder__bundle .h2").show();
		}

		$("#bb-add-to-cart").removeClass("xinline-block").addClass("xhidden");
	});

	$(document).on("click", "#bb-add-to-cart", function () {
		$("#my-bundle li").each(function () {
			const cart_message = $(".bb-cart-message");
			const var_id = $(this).attr("data-id");

			CartJS.addItem(
				var_id,
				1,
				{},
				{
					success(data, textStatus, jqXHR) {
						cart_message.html("Successfully added to basket.");

						setTimeout(() => {
							cart_message.html("");
						}, 5000);

						jQuery(".mini-cart").load(
							"/cart #MainContent #main-cart"
						);

						$(document)
							.find(".bb-remove-product")
							.each(function () {
								$(this).trigger("click");
							});
					},
					error(jqXHR, textStatus, errorThrown) {
						cart_message
							.addClass("message-error")
							.html("There was a problem adding to the basket!");
						setTimeout(() => {
							cart_message.html("").removeClass("message-error");
						}, 10000);
					},
				}
			);
		});
	});
}





	// Session styling bundle code

	if ($(".bundle-session-styling").length) {
		let bbCount = 0;
	
		$(document).on("click", ".bb-add-product", function () {
			if (bbCount < 1) {
				$(".bundle-builder__bundle .h2").hide();
			}
	
			bbCount++;
	
			if (bbCount < 3) {
				let bbProdID = $(this).attr("data-prodid");
				let bbProdImg = $(this)
					.closest(".col-sm-6")
					.find(".featured-collection__image img")
					.attr("src");
				let bbProdName = $(this).siblings("h3").html();
				let bbProdVolume = $(this).siblings("h4").html();
	
				if (!bbProdVolume) {
					bbProdVolume = " ";
				}
	
				$("#my-bundle").append(
					'<li class="col-sm-6 col-md-3 xflex xflex-col xcol-span-1 xtext-xs lg:xtext-base xleading-tight" data-id="' +
						bbProdID +
						'"><img src="' +
						bbProdImg +
						'"><span class="xblock">' +
						bbProdName +
						'<span style="margin-left: 10px; color: gray;">' +
						bbProdVolume +
						'</span></span><button style="margin-top: 10px;" class="button-alt bb-remove-product">Remove</button></li>'
				);
	
				$(this).siblings(".tick").addClass("showtick");
	
				if (bbCount == 2) {
					$(".bb-add-product").each(function () {
						$(this).prop("disabled", true);
						$(this).html("Bundle complete");
					});
	
					$("#bb-add-to-cart")
						.addClass("xinline-block")
						.removeClass("xhidden");
				}
			}
		});
	
		$(document).on("click", ".bb-remove-product", function () {
			$(".bb-add-product").each(function () {
				$(this).prop("disabled", false);
				$(this).html("Add to bundle");
			});
	
			let thisid = $(this).closest("li").attr("data-id");
	
			$(this).closest("li").remove();
	
			if (!$('#my-bundle li[data-id="' + thisid + '"]').length) {
				$(".bundle-builder__options")
					.find('button[data-prodid="' + thisid + '"]')
					.siblings(".tick")
					.removeClass("showtick");
			}
	
			bbCount--;
	
			if (bbCount < 1) {
				$(".bundle-builder__bundle .h2").show();
			}
	
			$("#bb-add-to-cart").removeClass("xinline-block").addClass("xhidden");
		});
	
		$(document).on("click", "#bb-add-to-cart", function () {
			$("#my-bundle li").each(function () {
				const cart_message = $(".bb-cart-message");
				const var_id = $(this).attr("data-id");
	
				CartJS.addItem(
					var_id,
					1,
					{},
					{
						success(data, textStatus, jqXHR) {
							cart_message.html("Successfully added to basket.");
	
							setTimeout(() => {
								cart_message.html("");
							}, 5000);
	
							jQuery(".mini-cart").load(
								"/cart #MainContent #main-cart"
							);
	
							$(document)
								.find(".bb-remove-product")
								.each(function () {
									$(this).trigger("click");
								});
						},
						error(jqXHR, textStatus, errorThrown) {
							cart_message
								.addClass("message-error")
								.html("There was a problem adding to the basket!");
							setTimeout(() => {
								cart_message.html("").removeClass("message-error");
							}, 10000);
						},
					}
				);
			});
		});
	}






// Xmas bundle code

if ($(".xmas-bundle-page").length) {
	let xmasbbCount = 0;

	$(document).on("click", ".bb-add-product", function () {
		if (xmasbbCount < 1) {
			$(".bundle-builder__bundle .h2").hide();
		}

		xmasbbCount++;

		if (xmasbbCount < 3) {
			let bbProdID = $(this).attr("data-prodid");
			let bbProdImg = $(this)
				.closest(".col-sm-6")
				.find(".featured-collection__image img")
				.attr("src");
			let bbProdName = $(this).siblings("h3").html();
			let bbProdVolume = $(this).siblings("h4").html();

			if (!bbProdVolume) {
				bbProdVolume = " ";
			}

			$("#my-bundle").append(
				'<li class="col-sm-6 col-md-3 xflex xflex-col xcol-span-1" data-id="' +
					bbProdID +
					'"><img src="' +
					bbProdImg +
					'"><span class="xblock">' +
					bbProdName +
					'<span style="margin-left: 10px; color: gray;">' +
					bbProdVolume +
					'</span></span><button style="margin-top: 10px;" class="button-alt bb-remove-product">Remove</button></li>'
			);

			$(this).siblings(".tick").addClass("showtick");

			if (xmasbbCount == 2) {
				$(".bb-add-product").each(function () {
					$(this).prop("disabled", true);
					$(this).html("Bundle complete");
				});

				$("#bb-add-to-cart")
					.addClass("xinline-block")
					.removeClass("xhidden");

				// add gift product

				let bbProdIDxx = $(".hidden_bundle_gift button").attr(
					"data-prodid"
				);
				let bbProdImgxx = $(".hidden_bundle_gift button")
					.closest(".col-sm-6")
					.find(".featured-collection__image img")
					.attr("src");
				let bbProdNamexx = $(".hidden_bundle_gift button")
					.siblings("h3")
					.html();
				let bbProdVolumexx = $(".hidden_bundle_gift button")
					.siblings("h4")
					.html();

				if (!bbProdVolumexx) {
					bbProdVolumexx = " ";
				}

				$("#my-bundle").append(
					'<li class="col-sm-6 col-md-3 xcol-span-1 xflex xflex-col free-gift-product xrelative" data-id="' +
						bbProdIDxx +
						'"><img style="padding: 20px" src="' +
						bbProdImgxx +
						'"><span class="d-block">' +
						bbProdNamexx +
						'<span style="margin-left: 10px; color: gray;">' +
						bbProdVolumexx +
						'</span></span><button class="badge xabsolute xtop-4 xright-4 xpointer-events-none">Free gift!</button><p style="font-size: small; margin-top: 5px;">Discount applied at checkout</p></li>'
				);
			}
		}
	});

	$(document).on("click", ".bb-remove-product", function () {
		$(".bb-add-product").each(function () {
			$(this).prop("disabled", false);
			$(this).html("Add to bundle");
		});

		let thisid = $(this).closest("li").attr("data-id");

		$(this).closest("li").remove();

		if (!$('#my-bundle li[data-id="' + thisid + '"]').length) {
			$(".bundle-builder__options")
				.find('button[data-prodid="' + thisid + '"]')
				.siblings(".tick")
				.removeClass("showtick");
		}

		xmasbbCount--;

		if (xmasbbCount < 1) {
			$(".bundle-builder__bundle .h2").show();
		}

		$("#bb-add-to-cart").removeClass("xinline-block").addClass("xhidden");

		if ($(".free-gift-product").length) {
			$(".free-gift-product").remove();
		}
	});

	$(document).on("click", "#bb-add-to-cart", function () {
		$("#my-bundle li").each(function () {
			const cart_message = $(".bb-cart-message");
			const var_id = $(this).attr("data-id");

			console.log(var_id);

			CartJS.addItem(
				var_id,
				1,
				{},
				{
					success(data, textStatus, jqXHR) {
						cart_message.html("Successfully added to basket.");

						

						// jQuery(".mini-cart").load(
						// 	"/cart #MainContent #main-cart"
						// );

						$(document)
							.find(".bb-remove-product")
							.each(function () {
								$(this).trigger("click");
							});

							$(document).on('cart.requestComplete', function(event, cart) {
								$('.cart-count-bubble span').html(cart.item_count);
							});


							setTimeout(() => {
								cart_message.html("");
							}, 5000);


					},
					error(jqXHR, textStatus, errorThrown) {
						cart_message
							.addClass("message-error")
							.html("There was a problem adding to the basket!");
						setTimeout(() => {
							cart_message.html("").removeClass("message-error");
						}, 10000);
					},
				}
			);
		});
	});
}




// free sample


$(document).on('cart.ready', function(event, cart) {
	
	let product_id = $('#free-sample').attr('data-free-sample')

	var hasFreeSample = CartJS.getAttribute('has-free-sample');
	if (hasFreeSample) {
		$('#free-sample').prop('checked', true)
	}

	$('#free-sample').change(function() {
		
		if (this.checked) {
			CartJS.addItem(product_id, 1, {}, {
				"success": function(data, textStatus, jqXHR) {

					CartJS.setAttribute('has-free-sample', true);
					$(document).on('cart.requestComplete', function(event, cart) {
						window.location.reload();
					});
					
				}
			})
		} else {
			CartJS.removeItemById(product_id, {
				"success": function(data, textStatus, jqXHR) {

					CartJS.clearAttributes();
					$(document).on('cart.requestComplete', function(event, cart) {
						window.location.reload();
					});

				}
			})
		}

	});

})


// resize side menu
window.addEventListener('resize', () => {
	if (window.innerWidth < 1280) {
		document.getElementById('menu-drawer').style.height = window.innerHeight + 'px'
	}
})


// Colletion header parallaz
gsap.fromTo(".collection-image img", { y: 0 },{
	y: 50,
	ease: "none",
	scrollTrigger: {
	  trigger: ".collection-image",
	  start: "top 100px",
	  scrub: true
	}, 
});

  // fade in up animation
ScrollTrigger.batch(".fiu", {
  onEnter: (elements, triggers) => {
    gsap.fromTo(elements, { opacity: 0, y: 40 }, {opacity: 1, y: 0, stagger: 0.15});
  },
  start: 'top 95%',
  once: true
});


// old style accordions
var acc = document.getElementsByClassName("os-acc");
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
	console.log('clickign');
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}


$('.slider-button--next').on('click', function(){

	let thisSlide = $('.slideshow__slide[aria-hidden="false"]').find('img')
	let thisSlideText = $('.slideshow__slide[aria-hidden="false"]').find('.slideshow__text')

	let next = $('.slideshow__slide[aria-hidden="false"]').next().find('img')
	let text = $('.slideshow__slide[aria-hidden="false"]').next().find('.slideshow__text')

	gsap.fromTo(thisSlide, { x: 0 }, { x: 500, duration: 1, ease: 'power1.in',
		onComplete: () => {
			gsap.set(thisSlide, {clearProps: true})
			gsap.set(thisSlideText, {clearProps: true})
		}
	})
	gsap.fromTo(thisSlideText, { autoAlpha: 1 }, { autoAlpha: 0, duration: .5})
	gsap.fromTo(next, { x: 500 }, { x: 0, duration: 1, ease: 'power1.out' })
	gsap.fromTo(text, { x: 500 }, { x: 0, duration: 1.1})
	
})

$('.slider-button--prev').on('click', function(){

	let thisSlide = $('.slideshow__slide[aria-hidden="false"]').find('img')
	let thisSlideText = $('.slideshow__slide[aria-hidden="false"]').find('.slideshow__text')

	let prev = $('.slideshow__slide[aria-hidden="false"]').prev().find('img')
	let text = $('.slideshow__slide[aria-hidden="false"]').prev().find('.slideshow__text')

	gsap.fromTo(thisSlide, { x: 0 }, { x: -500, duration: 1, ease: 'power1.in',
		onComplete: () => {
			gsap.set(thisSlide, {clearProps: true})
			gsap.set(thisSlideText, {clearProps: true})
		}
	})
	gsap.fromTo(thisSlideText, { autoAlpha: 1 }, { autoAlpha: 0, duration: .5})

	gsap.fromTo(prev, { x: -500 }, { x: 0, duration: 1, ease: 'power1.out' })
	gsap.fromTo(text, { x: -500 }, { x: 0, duration: 1.1})
})

$('.slider-counter__link--dots').on('click', function(){
	let dot = $(this)
	let currentSlideIndex = dot.closest('slideshow-component').find('.slideshow__slide[aria-hidden="false"]').index()
	let index = dot.index() + 1
	let direction = (currentSlideIndex > index) ? -200 : 200;
	let img = dot.closest('slideshow-component').find('.slideshow__slide:nth-child('+index+')').find('img')
	let text = dot.closest('slideshow-component').find('.slideshow__slide:nth-child('+index+')').find('.slideshow__text')

	gsap.fromTo(img, { x: direction }, { x: 0, duration: 1, ease: 'power1.out' })
	gsap.fromTo(text, { x: direction }, { x: 0, duration: 1.1})
})

// banner parallaz
$(".banner-section").each(function(){
	gsap.fromTo($(this).find('.banner-section-image'),
		{ y: '-10%' },
		{
			y: '10%',
			ease: "none",
			scrollTrigger: {
			trigger: $(this),
			start: "top 75%",
			end: "bottom 25%",
			scrub: true,
			// markers: true
		}, 
	});
})


// cta card section video popup

document.addEventListener("DOMContentLoaded", function() {
	const openModalBtn = document.querySelector(".open-modal-btn");
	const closeModalBtn = document.querySelector(".close-modal-btn");
	const modal = document.querySelector(".modal");
  
	// Open the modal when the button is clicked
	openModalBtn.addEventListener("click", function() {
	  modal.style.display = "block";
	});
  
	// Close the modal when the close button is clicked
	closeModalBtn.addEventListener("click", function() {
	  modal.style.display = "none";
	  // Stop the video when the modal is closed
	  const video = modal.querySelector("iframe");
	  video.src = video.src; // Resetting the video src to stop autoplay
	});
  
	// Close the modal when clicking outside the modal content
	window.addEventListener("click", function(event) {
	  if (event.target === modal) {
		modal.style.display = "none";
		// Stop the video when the modal is closed
		const video = modal.querySelector("iframe");
		video.src = video.src; // Resetting the video src to stop autoplay
	  }
	});
  });



